import { Module } from '../Module';

export interface LocalizeTranslateFilter {
  (translationId: string, interpolateParams: any, interpolation: string): string;
}

/**
 * A drop-in replacement for angular-translate's `translate` filter
 * that uses Localize under the hood instead. Should behave exactly as
 * the `translate` filter does. myork literally copied and pasted
 * the angular-translate filter source, but this is using our local
 * $translate service instead of the angular-translate $translate service
 */
Module.instance().filter('translate', [
  '$parse',
  '$translate',
  function($parse: ng.IParseService, $translate: ng.translate.ITranslateService) {
    const translateFilter = function(translationId: string, interpolateParams: any, interpolation: string) {
      if (!angular.isObject(interpolateParams)) {
        interpolateParams = $parse(interpolateParams)(this);
      }
      return $translate.instant(translationId, interpolateParams, interpolation);
    };
    (translateFilter as any).$stateful = true;
    return translateFilter;
  }
]);
